import { render, staticRenderFns } from "./CardEquipment.vue?vue&type=template&id=f9c6e7c2&scoped=true"
import script from "./CardEquipment.vue?vue&type=script&lang=js"
export * from "./CardEquipment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9c6e7c2",
  null
  
)

export default component.exports